import { type RequestMiddleware, type ResponseMiddleware, GraphQLClient } from 'graphql-request'
import { sessionStore } from '@gto/gw-store'
import store from '../index'
import { getAuthHeader, setAuthHeader } from './helpers'

const endpoint = import.meta.env.VITE_API_URL?.replace('v1', 'v3').concat('graphql/')

const responseMiddleware: ResponseMiddleware = async response => {
  // @ts-expect-error There is a bad typed definition in graphql-request ResponseMiddleware
  if (response && response.response?.status === 401) {
    await store.dispatch('tokenRefresh')
  }
}

const requestMiddleware: RequestMiddleware = request => {
  if (!request.headers) return request

  const accessToken = sessionStore.getState().accessToken

  if (getAuthHeader(request.headers) === `Bearer ${accessToken}`) return request

  // eslint-disable-next-line no-use-before-define
  graphQLClient.setHeader('authorization', `Bearer ${accessToken}`)

  return setAuthHeader<Parameters<RequestMiddleware>[0]>(request, `Bearer ${accessToken}`)
}

const accessToken = sessionStore.getState().accessToken
const requestConfig = {
  headers: {
    authorization: `Bearer ${accessToken}`,
    GWCLIENTID: sessionStore.getState().appUid,
  },
  responseMiddleware,
  requestMiddleware,
}

export const graphQLClient = new GraphQLClient(endpoint, requestConfig)
